/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AuthGuard } from '../../../../../core/guards';
import { BackupRestoreApiService } from '../../../shared/http';
import { BackupRestoreComponent } from './backupRestore.component';
import { BackupRestoreResolver } from '../../../shared/resolvers';
import { DownloadService } from '../../../../../core/services';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';
import { RestoreBackupComponent } from './restore-backup/restore-backup.component';
import { TitleCasePipe } from '@angular/common';
import { UploadBackupComponent } from './upload-backup/upload-backup.component';
import { UserInterfaceModule } from '../../localConfiguration/userInterface/userInterface.module';

/**
 *
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule,
        UserInterfaceModule
    ],
    declarations: [
        BackupRestoreComponent,
        UploadBackupComponent,
        RestoreBackupComponent
    ],
    providers: [
        AuthGuard,
        BackupRestoreResolver,
        BackupRestoreApiService,
        DownloadService,
        TitleCasePipe
    ]
})

export class BackupRestoreModule {
}
